module.exports = __webpack_public_path__ + "furniture.6ca7050b1a7b94002612.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/furniture/webfont/furniture.eot
// module id = ../../../../../src/assets/fonts/line-icons-pro/furniture/webfont/furniture.eot
// module chunks = styles